var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTemepraturePrecision = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2396 20.714C15.3606 20.9876 15.4664 21.2687 15.5563 21.5563C16.0517 23.1422 16.0356 24.8439 15.5101 26.4202C14.9847 27.9965 13.9766 29.3675 12.6287 30.3391C11.2807 31.3106 9.66125 31.8334 7.99968 31.8334C6.33811 31.8334 4.71866 31.3106 3.37072 30.3391C2.02279 29.3675 1.0147 27.9965 0.489265 26.4202C-0.0361692 24.8439 -0.0523173 23.1422 0.443109 21.5563C0.938535 19.9703 1.92042 18.5804 3.24968 17.5834V4.91675C3.24968 3.65697 3.75012 2.44879 4.64092 1.55799C5.53172 0.667193 6.7399 0.166748 7.99968 0.166748C9.25946 0.166748 10.4677 0.667193 11.3585 1.55799C12.2493 2.44879 12.7497 3.65697 12.7497 4.91675V6.36495C11.3306 7.26667 10.2164 8.561 9.58301 10.0824V4.91675C9.58301 4.49682 9.4162 4.0941 9.11926 3.79716C8.82233 3.50023 8.4196 3.33341 7.99968 3.33341C7.57975 3.33341 7.17703 3.50023 6.88009 3.79716C6.58316 4.0941 6.41635 4.49682 6.41635 4.91675V16.0001H9.58301V15.9176C10.5525 18.2462 12.6483 20.0429 15.2396 20.714Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10V10.6M17 15.4V16M14.6 13H14M20 13H19.4M17 19C20.3138 19 23 16.3138 23 13C23 9.6862 20.3138 7 17 7C13.6862 7 11 9.6862 11 13C11 16.3138 13.6862 19 17 19Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTemepraturePrecision);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/temepraturePrecision.2aff54043518e03873aa978154af6b9d.svg";